import React from 'react'

/**
 * A section header over plot rows (wave 7): the stamped group's label in its
 * tone. Shared by choice-bars and grouped-bars by row; the plot draws a header
 * before the first row of each group, rows as stamped (never sorted here).
 */

export interface PlotSection {
  id: string
  label: string
  tone: 'positive' | 'mixed' | 'negative'
}

const SECTION_TONE_CLASS: Record<PlotSection['tone'], string> = {
  positive: 'bg-chart-positive/10 text-chart-positive',
  mixed: 'bg-chart-warning/10 text-chart-warning',
  negative: 'bg-destructive/10 text-destructive',
}

export function SectionHeader(props: { group: PlotSection; testIdPrefix: string }) {
  const { group, testIdPrefix } = props

  return (
    <div data-testid={`${testIdPrefix}-group-${group.id}`} data-tone={group.tone}>
      <span className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium leading-4 ${SECTION_TONE_CLASS[group.tone]}`}>
        {group.label}
      </span>
    </div>
  )
}

/** The section header drawn before `entries[index]`: the group it opens, or null mid-section and for ungrouped rows. */
export function sectionOpenedAt(
  entries: Array<{ groupId?: string | null }>,
  index: number,
  groups: Map<string, PlotSection>,
): PlotSection | null {
  const groupId = entries[index].groupId
  if (!groupId || (index > 0 && entries[index - 1].groupId === groupId)) {
    return null
  }
  return groups.get(groupId) ?? null
}
